<h1 mat-dialog-title>Alterar status pedidos em demanda</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="max-width: '500';">

    <div class="row">
        <div class="col-sm">
            <div class="row mt-2" *ngIf="pedidosConfirmados.length > 0">
                <div class="col-sm" style="max-width: 400px;">
                    <strong>Pedidos 'Confirmados':</strong> {{sAuxConfirmados}}
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="fill" [floatLabel]="'always'">
                        <mat-label>Novo status para 'Confirmado'</mat-label>
                        <mat-select [(ngModel)]="sStatusConfirmados">
                            <mat-option [value]="'Em separação'">Em separação</mat-option>
                            <mat-option [value]="'Em rota'">Em rota</mat-option>
                            <mat-option [value]="'Entregue'">Entregue</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="fill">
                        <mat-label>Previsão de entrega</mat-label>
                        <input matInput [matDatepicker]="picker" [(ngModel)]="datePrevisaoEntrega" [min]="minDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <div style="font-size: x-small; color: gray; position: absolute; margin-top: -20px; margin-right: 16px;">*Apenas para os pedidos em que não há o dado de previsão de entrega informado</div>
                </div>
            </div>

            <div class="row mt-4" *ngIf="pedidosEmSeparacao.length > 0">
                <div class="col-sm">
                    <mat-divider></mat-divider>
                </div>
            </div>

            <div class="row mt-4" *ngIf="pedidosEmSeparacao.length > 0">
                <div class="col-sm" style="max-width: 400px;">
                    <strong>Pedidos 'Em separação':</strong> {{sAuxEmSeparacao}}
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="fill" [floatLabel]="'always'">
                        <mat-label>Novo status para 'Em separação'</mat-label>
                        <mat-select [(ngModel)]="sStatusEmSeparacao">
                            <mat-option [value]="'Em rota'">Em rota</mat-option>
                            <mat-option [value]="'Entregue'">Entregue</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-4" *ngIf="pedidosEmRota.length > 0">
                <div class="col-sm">
                    <mat-divider></mat-divider>
                </div>
            </div>

            <div class="row mt-4" *ngIf="pedidosEmRota.length > 0">
                <div class="col-sm" style="max-width: 400px;">
                    <strong>Pedidos 'Em rota':</strong> {{sAuxEmRota}}
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="fill" [floatLabel]="'always'">
                        <mat-label>Novo status para 'Em rota'</mat-label>
                        <mat-select [(ngModel)]="sStatusEmRota" disabled>
                            <mat-option [value]="'Entregue'">Entregue</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="cancelar()">
            <mat-icon>clear</mat-icon> Cancelar
        </button>
        <button mat-flat-button color="primary" (click)="confirmarAlteracaoStatus()">
            <mat-icon>check</mat-icon> Confirmar alteração
        </button>
    </section>
</div>
